/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import iconAdjustments from "../../../../assets/icons/adjustments.svg";
import TabsParametrizacao from "../../../../partials/TabsParametrizacao";
import Loading from "../../../home/components/Loading";
import { LogsView } from "./Components/LogsView";

const LogsListing = (props) => {
  window.setPageTitle("Logs");

  const LOGS_PROCESSO = "LOGS";

  const [loading, setLoading] = useState(false);
  const [titles, setTitles] = useState([LOGS_PROCESSO]);

  const getIndexFromAdminTab = (tabTitle) => {
    return titles.findIndex((title) => title === tabTitle);
  };
  return (
    <>
      <Loading isLoading={loading} />
      <TabsParametrizacao
        title="Logs"
        icon={iconAdjustments}
        titles={titles}
        contents={[<LogsView />]}
        adminTabs={{ index: [getIndexFromAdminTab(LOGS_PROCESSO)] }}
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(LogsListing);
